import axios from 'axios';
import APIS from '../../apis/toutiao';
import qs from 'qs';
import {
  callbackHandler,
  YIAPIcallbackHandler,
} from '../callbackHandler';

export default {
  state: {
    extendPlatform: 'tiktok'
  },
  mutations: {
    switchPlatform(state, platform) {
      state.extendPlatform = platform
    }
  },
  getters: {
    extendPlatform: state => state.extendPlatform
  },
  actions: {
    //首页头条收益列表数据
    myRewardList(context, params) {
      console.log('--- myRewardList ---', params);
      return axios.get(APIS.myRewardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.myRewardList, res);
        return res.data;
      })
    },
    //首页头条收益总览
    myReward(context, params) {
      console.log('--- myReward ---', params);
      return axios.get(APIS.myReward, {
          params: params.params
      }).then(function (res) {
          callbackHandler(APIS.myReward, res);
          return res.data;
      })
    },
    //首页头条 推广列表
    promoQrcodeList(context, params) {
      console.log('--- promoQrcodeList ---', params);
      return axios.get(APIS.promoQrcodeList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoQrcodeList, res);
        return res.data;
      })
    },
    //推广中心-获取用户信息
    promoGetUser(context, params) {
      console.log('--- promoGetUser ---', params);
      return axios.get(APIS.promoGetUser, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoGetUser, res);
        return res.data;
      })
    },
    //推广中心-获取用户信息
    promoGetQrCode(context, params) {
      console.log('--- promoGetQrCode ---', params);
      return axios.get(APIS.promoGetQrCode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoGetQrCode, res);
        return res.data;
      })
    },
    // 推广中心-获取实名认证信息
    getRealNameInfo(context, params) {
      console.log('--- getRealNameInfo ---', params);
      return axios.get(APIS.getRealNameInfo, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getRealNameInfo, res);
        return res.data;
      })
    },
    // 推广中心-提交实名认证信息
    saveRealNameInfo(context, { env, params, callback } = {}) {
      console.log('--- saveRealNameInfo ---', params);
      return axios.post(APIS.saveRealNameInfo,
          qs.stringify(params)
        ).then(function (res) {
        // callbackHandler(APIS.saveRealNameInfo, res, callback, true);
        callback(res.data)
        return res;
      })
    },

    //首页头条收益列表数据 -- 每日
    myRewardListDay(context, params) {
      console.log('--- myRewardListDay ---', params);
      return axios.get(APIS.myRewardListDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.myRewardListDay, res);
        return res.data;
      })
    },
    //首页头条收益总览 -- 每日
    myRewardDay(context, params) {
      console.log('--- myRewardDay ---', params);
      return axios.get(APIS.myRewardDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.myRewardDay, res);
        return res.data;
      })
    },
    //首页头条团队收益总览 -- 每日
    myTeamRewardDay(context, params) {
      console.log('--- myTeamRewardDay ---', params);
      return axios.get(APIS.myTeamRewardDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.myTeamRewardDay, res);
        return res.data;
      })
    },
    //推广中心-提现列表 -- 每日
    postWithdrawDay(context, { env, params, callback } = {}) {
      console.log('--- withdrawDay ---', params);
      return axios.post(APIS.withdrawDay, qs.stringify(params)).then(function (res) {
        callbackHandler(APIS.withdrawDay, res);
        return res.data;
      })
    },
    //推广中心-提现列表 -- 每日
    withdrawListDay(context, params) {
      console.log('--- withdrawListDay ---', params);
      return axios.get(APIS.withdrawListDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.withdrawListDay, res);
        return res.data;
      })
    },
    // 上传图片
    uploadImage(context, { env, params, callback } = {}) {
      console.log('--- uploadImage ---', params);
      return axios.post(APIS.uploadImage,
        params
      ).then(function (res) {
        // callbackHandler(APIS.uploadImage, res, callback, true);
        callback(res.data)
        return res;
      })
    },

    // 发送验证码
    sendValidcode(context, { env, params, callback } = {}) {
      console.log('--- sendValidcode ---', params);
      return axios.post(APIS.sendValidcode,
        qs.stringify(params)
      ).then(function (res) {
        YIAPIcallbackHandler(APIS.sendValidcode, res, callback, true);
        return res;
      })
    },
    // 验证码验证登陆
    validcodeLogin(context, { env, params, callback } = {}) {
      console.log('--- validcodeLogin ---', params);
      return axios.post(APIS.validcodeLogin,
        qs.stringify(params)
      ).then(function (res) {
        YIAPIcallbackHandler(APIS.validcodeLogin, res, callback, true);
        return res;
      })
    },
    //推广中心-提现列表
    withdrawList(context, params) {
      console.log('--- withdrawList ---', params);
      return axios.get(APIS.withdrawList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.withdrawList, res);
        return res.data;
      })
    },
    //推广中心-申请提现
    postWithdraw(context, { env, params, callback } = {}) {
      console.log('--- withdraw ---', params);
      return axios.post(APIS.withdraw, qs.stringify(params)).then(function (res) {
        callbackHandler(APIS.withdraw, res);
        return res.data;
      })
    },
    //推广中心-我的团队收益
    promoTeamRewards(context, params) {
      console.log('--- promoTeamRewards ---', params);
      return axios.get(APIS.promoTeamRewards, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoTeamRewards, res);
        return res.data;
      })
    },
    //推广中心-绑定推荐人
    promoBind(context, { env, params, callback } = {}) {
      console.log('--- promoBind ---', params);
      return axios.post(APIS.promoBind, qs.stringify(params)).then(function (res) {
        callbackHandler(APIS.promoBind, res);
        return res.data;
      })
    },
    // 推广中心-绑定抖音号昵称
    getBindToutiaoUsers(context, params) {
      console.log('--- getBindToutiaoUsers ---', params);
      return axios.get(APIS.getBindToutiaoUsers, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getBindToutiaoUsers, res);
        return res.data;
      })
    },
    //推广中心-生成分销卡
    promoGetPromoCard(context, { env, params, callback } = {}) {
      console.log('--- promoGetPromoCard ---', params);
      return axios.post(APIS.promoGetPromoCard, qs.stringify(params)).then(function (res) {
        callbackHandler(APIS.promoGetPromoCard, res);
        return res.data;
      })
    },
    //推广中心-统计数据
    getStatisticData(context, params) {
      console.log('--- getStatisticData ---', params);
      return axios.get(APIS.getStatisticData, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getStatisticData, res);
        return res.data;
      })
    },
    // 获取推广中心服务协议阅读状态、pdf链接
    getCooperationPdf(context, params) {
      console.log('--- getCooperationPdf ---', params);
      return axios.get(APIS.getCooperationPdf, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getCooperationPdf, res);
        return res.data;
      })
    },
    // 获取授权码链接
    promoAuthUrl(context, params) {
      console.log('--- promoAuthUrl ---', params);
      return axios.get(APIS.promoAuthUrl, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoAuthUrl, res);
        return res.data;
      })
    },
    // 获取授权码链接
    getADStatData(context, params) {
      console.log('--- getADStatData ---', params);
      return axios.get(APIS.getADStatData, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getADStatData, res);
        return res.data;
      })
    },
    // 获取小程序列表
    promoAppList(context, params) {
      // console.log('--- promoAppList ---', params);
      return axios.get(APIS.promoAppList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoAuthUrl, res);
        return res.data;
      })
    },
    //推广中心-团队贡献排行榜
    admyTeamRewardList(context, params) {
      console.log('--- admyTeamRewardList ---', params);
      return axios.get(APIS.admyTeamRewardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.admyTeamRewardList, res);
        return res.data;
      })
    },
    //推广中心-获取资料包
    promoPackagePop(context, params) {
      console.log('--- promoPackagePop ---', params);
      return axios.get(APIS.promoPackagePop, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoPackagePop, res);
        return res.data;
      })
    },
    //推广中心-搜索测试
    promoSearchScale(context, params) {
      console.log('--- promoSearchScale ---', params);
      return axios.get(APIS.promoSearchScale, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoSearchScale, res);
        return res.data;
      })
    },
    //推广中心-测试生成推广码
    promoSearchScaleCode(context, params) {
      console.log('--- promoSearchScaleCode ---', params);
      return axios.get(APIS.promoSearchScaleCode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoSearchScaleCode, res);
        return res.data;
      })
    },
    //推广中心-测试生成推广码
    promoUserAuthList(context, params) {
      // console.log('--- promoUserAuthList ---', params);
      return axios.get(APIS.promoUserAuthList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.promoUserAuthList, res);
        return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/toutiao_app.js